import React from 'react';
import logo from '../../../assets/img/logo.png';
import useGlobal from '../../../store';
import { useHistory } from 'react-router-dom';

function HeaderMobile() {

  const history = useHistory();

  const toggle = () => {
    uiActions.toggleMobileSubmenu();
  }

  const [user, uiActions] = useGlobal(
    state => state.user,
    actions => actions.uiActions
  );

  const buildAvatarUrl = (userData) => {
    if(userData.hasOwnProperty('avatarFile') && userData.avatarFile && (userData.avatarFile.indexOf('_avatar') > 0 || userData.avatarFile.length > 30)) {
      return <img className="avatar avatar-xs" src={"https://weblight.imgix.net/avatars/"+userData.avatarFile + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2"} alt="" />;
    }
    // if(userData.FBID && userData.FBID !== "0") {
    //   return <img className="avatar avatar-xs" src={"https://graph.facebook.com/" + userData.FBID + "/picture?type=large"} alt="" />;
    // }
    return (<div className="kt-media kt-media--xs kt-media--circle kt-media--info">
        <span>{userData.FirstName ? userData.FirstName.charAt(0) : '?'}{userData.LastName ? userData.LastName.charAt(0) : ''}</span>
    </div>);
  }

  const goToHome = () => {
    history.push('/my-giftlist');
  }

  const styles = {
    height: "34px",
    width: "34px",
    border: "1px solid rgb(231, 232, 244)",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignSelf: "center",
    cursor: "pointer",
    marginLeft: "5px",
    alignItems: "center",
    fontSize: "18px"
  }
  return (
    <div id="kt_header_mobile" className="kt-header-mobile  kt-header-mobile--fixed ">
        <div className="kt-header-mobile__logo">
            <a href="index.html">
                <img style={{height:"40px"}} alt="Logo" src={logo} />
            </a>
        </div>
        <div className="kt-header-mobile__toolbar">
            {user ? <div onClick={()=> goToHome()}>{buildAvatarUrl(user)}</div> : <></>}
            <div onClick={() => uiActions.toggleSidePanel("nicelist")} style={styles} className="kt-header__topbar-item">
              <div className="kt-header__topbar-wrapper">
                <span className="kt-header__topbar-icon"><i className="flaticon2-gift-1"></i></span>
              </div>
            </div>
            <div onClick={() => uiActions.toggleSidePanel("shoppinglist")} style={styles} className="kt-header__topbar-item">
              <div className="kt-header__topbar-wrapper">
                <span className="kt-header__topbar-icon"><i className="flaticon-price-tag"></i></span>
              </div>
            </div>
            <button onClick={() => toggle()} className="kt-header-mobile__toolbar-topbar-toggler"><i className="flaticon-more"></i></button>
        </div>
    </div>

  );
}

export default HeaderMobile;